module.exports = __webpack_public_path__ + "static/media/dave.ab75af87.jpeg";